import React from "react";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import ChatWidget from "./components/ChatWidget";
import WhatsAppButton from "./components/WhatsAppButton";
import LoginModal from "./components/LoginModal";
import ReviewsSection from "./components/ReviewsSection";
import Home from "./pages/Home";
import Collection from "./pages/Collection";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import Login from "./pages/Login";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import TrackOrder from "./pages/TrackOrder";
import MyOrders from "./pages/MyOrders";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import AreaPage from "./pages/AreaPage";
import OccasionPage from "./pages/OccasionPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const FooterReviews = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || pathname.startsWith("/checkout")) return null;
  return <ReviewsSection />;
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Header />
            <CartDrawer />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/collections/:slug" element={<Collection />} />
                <Route path="/products/:slug" element={<ProductDetail />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/login" element={<Login />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/track-order" element={<TrackOrder />} />
                <Route path="/my-orders" element={<MyOrders />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/cake-delivery/:area" element={<AreaPage />} />
                <Route path="/occasions/:slug" element={<OccasionPage />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <FooterReviews />
            <Footer />
            <ChatWidget />
            <WhatsAppButton />
            <LoginModal />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
